import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { TemplateService } from '../services/template.service';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { AddTemplateComponent } from './add-template/add-template.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-citacion-templates',
    templateUrl: './citacion-templates.component.html',
    styleUrls: ['./citacion-templates.component.scss'],
    standalone: false
})
export class CitacionTemplatesComponent {

    constructor() { }

}
